import { useMemo } from 'react';
import { useI18n as useI18nManager } from '@funtech-int/rival-react';

import { getDayAndMonthFromDate } from '../lib/date';

import { useI18n } from './useI18n';

export function useAnnounceI18n() {
    const i18n = useI18n();
    const locale = useI18nManager().locale.get();

    return useMemo(() => {
        function getPromise(promise: string) {
            switch (promise) {
                case 'SOON':
                    return i18n('announce__promise__soon');
                case 'THIS_SUMMER':
                    return i18n('announce__promise__summer');
                case 'THIS_AUTUMN':
                    return i18n('announce__promise__autumn');
                case 'THIS_WINTER':
                    return i18n('announce__promise__winter');
                case 'THIS_SPRING':
                    return i18n('announce__promise__spring');
                default:
                    return undefined;
            }
        }

        function getPromiseSubscription() {
            return i18n('announce_promise__subscription');
        }

        return {
            getPromise,
            getPromiseSubscription,
            getSeason() {
                return i18n('announce__new_season');
            },
            getAnnounceText(announceDate: string, promise: string) {
                const promiseText = getPromise(promise);

                const { day, month } = getDayAndMonthFromDate(announceDate || '', locale.lang);

                if (!promiseText && month) {
                    return i18n('announce_promise__date', {
                        watchingOptionType: 'SUBSCRIPTION',
                        day,
                        month,
                    });
                }

                return `${promiseText?.replace(' ', '\u00A0')} ${
                    getPromiseSubscription()?.replace(' ', '\u00A0') || ''
                }`;
            },
        };
    }, [i18n, locale.lang]);
}
